import { createSlice } from "@reduxjs/toolkit";

export const templateSlice = createSlice({
  name: "template",
  initialState: {
    smsTemplates: [],
    emailTemplates: [],
    isSmsTemplateSendSuccess: false,
    isSmsTemplateUpdateError: false,
    isEmailTemplateSendSuccess: false,
    isLogEmailSendSuccess: false,
    logEmailResponseData: null,
    smsNotificationLists: null,
    smsNotificationListPagination: {},
    isMarkSmsResponse: false,
  },
  reducers: {
    getSmsTemplateAction: (state) => {},
    setSmsTemplateAction: (state, { payload }) => {
      console.log("payload", payload);
      state.smsTemplates = payload;
    },

    sendSmsTemplateAction: (state, { payload }) => {},
    setSendSmsTemplateAction: (state, { payload }) => {
      state.isSmsTemplateSendSuccess = payload;
    },

    getEmailTemplateAction: (state) => {},
    setEmailTemplateAction: (state, { payload }) => {
      state.emailTemplates = payload;
    },

    sendEmailTemplateAction: (state, { payload }) => {},
    setSendEmailTemplateAction: (state, { payload }) => {
      state.isEmailTemplateSendSuccess = payload;
    },

    sendLogEmailAction: (state, { payload }) => {},
    setSendLogEmailResponseAction: (state, { payload }) => {
      state.isLogEmailSendSuccess = payload;
    },
    setLogEmailResponseDataAction: (state, { payload }) => {
      state.logEmailResponseData = payload;
    },

    getSmsNotificationListAction: (state, { payload }) => {},
    setSmsNotificationListResponse: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.smsNotificationLists = list;
      state.smsNotificationListPagination = pagination;
    },

    markSmsReadAction: (state, { payload }) => {},
    makrSmsReadResponse: (state, { payload }) => {
      state.isMarkSmsResponse = payload;
    },
  },
});

const {
  getSmsTemplateAction,
  setSmsTemplateAction,
  sendSmsTemplateAction,
  setSendSmsTemplateAction,
  getEmailTemplateAction,
  setEmailTemplateAction,
  sendEmailTemplateAction,
  setSendEmailTemplateAction,
  sendLogEmailAction,
  setSendLogEmailResponseAction,
  setLogEmailResponseDataAction,
  getSmsNotificationListAction,
  setSmsNotificationListResponse,
  markSmsReadAction,
  makrSmsReadResponse,
} = templateSlice.actions;

export {
  getSmsTemplateAction,
  setSmsTemplateAction,
  sendSmsTemplateAction,
  setSendSmsTemplateAction,
  getEmailTemplateAction,
  setEmailTemplateAction,
  sendEmailTemplateAction,
  setSendEmailTemplateAction,
  sendLogEmailAction,
  setSendLogEmailResponseAction,
  setLogEmailResponseDataAction,
  getSmsNotificationListAction,
  setSmsNotificationListResponse,
  markSmsReadAction,
  makrSmsReadResponse,
};

export default templateSlice.reducer;
